import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % banners.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((p) => (p - 1 + banners.length) % banners.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-700"
        style={{ backgroundImage: `url(${banner.image})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="absolute inset-0 flex items-center">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
          <div className="max-w-xl">
            <span className="inline-block bg-accent-500/90 text-background-50 text-xs font-semibold px-3 py-1 rounded-full mb-3">
              {banner.subtitle}
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3 leading-tight">
              {banner.title}
            </h1>
            <p className="text-background-100/80 text-sm md:text-base mb-6 leading-relaxed">
              {banner.description}
            </p>
            <Link
              to={`/article/${banner.comicId}`}
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-line"></i>
              开始阅读
            </Link>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 transition-colors"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 transition-colors"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all ${
              i === current ? 'bg-primary-500 w-5' : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
            aria-label={`切换到第${i + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}